import { useState, useEffect } from "react";

// Helpers — inicio y fin de mes
const obtenerInicioMes = (fecha) =>
  new Date(fecha.getFullYear(), fecha.getMonth(), 1, 0, 0, 0, 0);

const obtenerFinMes = (fecha) =>
  new Date(fecha.getFullYear(), fecha.getMonth() + 1, 0, 23, 59, 59, 999);

export const useVentasMensuales = (productos) => {
  const [data, setData] = useState({
    productosMesActual: [],
    productosMesAnterior: [],
    totalMesActual: 0,
    totalMesAnterior: 0
  });

  useEffect(() => {
    if (!productos || productos.length === 0) return;

    const hoy = new Date();

    // 📌 Mes actual
    const inicioMesActual = obtenerInicioMes(hoy);
    const finMesActual = hoy;

    // 📌 Mes anterior
    const fechaMesAnterior = new Date(hoy.getFullYear(), hoy.getMonth() - 1);
    const inicioMesAnterior = obtenerInicioMes(fechaMesAnterior);
    const finMesAnterior = obtenerFinMes(fechaMesAnterior);

    // 📌 Obtener fecha real del producto
    const fechaProducto = (p) => new Date(p.fecha_creacion || p.createdAt);

    // 📌 Función para sumar valores
    const sumarProducto = (p) =>
      Number(p.total) -
      Number(p?.descuento ?? 0);

    // 📌 Filtrar productos por mes actual
    const productosMesActual = productos.filter((p) => {
      const fecha = fechaProducto(p);
      return fecha >= inicioMesActual && fecha <= finMesActual;
    });

    // 📌 Filtrar productos por mes anterior
    const productosMesAnterior = productos.filter((p) => {
      const fecha = fechaProducto(p);
      return fecha >= inicioMesAnterior && fecha <= finMesAnterior;
    });

    // 📌 Totales

    const sumarVentaValida = (acc, venta) => {
      const estaAbierta = venta?.estado === 1;
      const tieneAbonos = (venta?.AbonoVentasRapidas?.length ?? 0) > 0;

      if (estaAbierta || tieneAbonos) return acc;

      const totalVenta =
        Number(venta?.total ?? 0) -
        Number(venta?.descuento ?? 0);

      return acc + totalVenta;
    };

    const totalMesActual = productosMesActual.reduce(
      (acc, venta) => sumarVentaValida(acc, venta),
      0
    );

    const totalMesAnterior = productosMesAnterior.reduce(
      (acc, venta) => sumarVentaValida(acc, venta),
      0
    );

    const totalAbonosMesActual = productosMesActual.reduce(
      (acc, venta) => acc + Number(venta?.totalAbonos ?? 0),
      0
    );

    setData({
      productosMesActual,
      productosMesAnterior,
      totalMesActual,
      totalMesAnterior,
      totalAbonosMesActual
    });

  }, [productos]);

  return data;
};

